/**
 * Calendar-date helpers without timezone shifts (billing, RPM, DOB, etc.).
 */

/** @returns {string|null} YYYY-MM-DD */
export function normalizeDateOnly(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? match[0] : null;
}

/** Value safe for `<input type="date">`. */
export function toDateInputValue(value) {
  return normalizeDateOnly(value) || '';
}

/** MM/DD/YYYY */
export function formatDateOnlyUs(value) {
  const ymd = normalizeDateOnly(value);
  if (!ymd) return null;
  const [y, m, d] = ymd.split('-');
  return `${m}/${d}/${y}`;
}

/** MM-DD-YYYY */
export function formatDateOnlyDash(value) {
  const ymd = normalizeDateOnly(value);
  if (!ymd) return null;
  const [y, m, d] = ymd.split('-');
  return `${m}-${d}-${y}`;
}

export function formatDateOnlyForDisplay(value, style = 'us') {
  return style === 'dash' ? formatDateOnlyDash(value) : formatDateOnlyUs(value);
}

export function formatDateOnlyRange(from, to, { separator = ' ~ ', style = 'us' } = {}) {
  const a = formatDateOnlyForDisplay(from, style);
  const b = formatDateOnlyForDisplay(to, style);
  if (!a || !b) return 'N/A';
  return `${a}${separator}${b}`;
}

export function compareDateOnly(a, b) {
  const left = normalizeDateOnly(a);
  const right = normalizeDateOnly(b);
  if (!left || !right) return 0;
  return left.localeCompare(right);
}

/** For `<input type="date">` min/max and date pickers — local today as YYYY-MM-DD. */
export function getTodayDateOnlyLocal() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export const DATE_OF_BIRTH_FUTURE_ERROR = 'Date of Birth cannot be in the future';

/** True when value is a calendar date after today (local). */
export function isDateOnlyAfterToday(value) {
  const ymd = normalizeDateOnly(value);
  if (!ymd) return false;
  return ymd > getTodayDateOnlyLocal();
}

/** `max` for patient date-of-birth inputs. */
export function getMaxDateOfBirthForInput() {
  return getTodayDateOnlyLocal();
}
